module.exports = __webpack_public_path__ + "static/media/72.a69dcbf7.jpg";